(function () {
  class ImageText {
    constructor(section) {
      this.section = section;
      this.sliderEl = section.querySelector('[data-it-slider]');
      this.prevBtn = section.querySelector('[data-it-prev]');
      this.nextBtn = section.querySelector('[data-it-next]');
      this.swiper = null;

      if (this.sliderEl) {
        this._initSwiper();
      }
    }

    _updateNav() {
      const nav = this.section.querySelector('[data-it-nav]');
      if (!nav || !this.prevBtn || !this.nextBtn) return;
      nav.classList.toggle('is-hidden', this.prevBtn.disabled && this.nextBtn.disabled);
    }

    _initSwiper() {
      if (!window.Swiper) return;

      const el = this.sliderEl;
      const perViewTablet  = parseInt(el.dataset.perViewTablet)  || 2;
      const perViewDesktop = parseInt(el.dataset.perViewDesktop) || 3;
      const speed          = parseInt(el.dataset.speed)          || 600;
      const autoplayDelay  = parseInt(el.dataset.autoplay)       || 0;

      const config = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: speed,
        enabled: false,
        navigation: {
          prevEl: this.prevBtn,
          nextEl: this.nextBtn,
        },
        breakpoints: {
          768: {
            enabled: true,
            slidesPerView: perViewTablet,
            spaceBetween: 20,
          },
          1024: {
            enabled: true,
            slidesPerView: perViewDesktop,
            spaceBetween: 30,
          },
        },
        on: {
          init: () => this._updateNav(),
          slideChange: () => this._updateNav(),
        },
      };

      if (autoplayDelay > 0) {
        config.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
      }

      this.swiper = new Swiper(el, config);
    }
  }

  function init() {
    document.querySelectorAll('[data-section-type="image-text"]').forEach(function (el) {
      new ImageText(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="image-text"]');
    if (section) new ImageText(section);
  });
})();
